import { Component, Input } from '@angular/core';
import type { FormGroup } from '@angular/forms';

import type { LocationsSectionTranslations } from '@core/locations-legacy';
import {
  AssignLocationsFacade,
  LocationSectionTranslationsToken,
  LocationsAnalytics,
  LocationsSectionComponent,
  LocationsSectionViewContext,
  ReorderLocationsFacade,
  UnassignLocationFacade,
} from '@core/locations-legacy';

import { AssignLocationsRequisitionFacade } from '../../../facades/single-requisition/assign-locations-requisition.facade';
import { ReorderLocationsRequisitionFacade } from '../../../facades/single-requisition/reorder-locations-requisition-facade.service';
import { UnassignLocationRequisitionFacade } from '../../../facades/single-requisition/unassign-location-requisition-facade.service';
import type { RequisitionForm } from '../../../requisitions.types';

const translations: LocationsSectionTranslations = {
  heading: 'app.requisitions.details_page.location.heading',
  subheading: 'app.requisitions.details_page.location.subheading',
  archiveBadgeTooltip: 'app.requisitions.details_page.location.archived_location_badge_tooltip',
  assignLocation: 'app.requisitions.details_page.location.assign_location',
  emptyState: {
    title: 'app.requisitions.details_page.location.empty_state.title',
    description: 'app.requisitions.details_page.location.empty_state.description',
  },
};

@Component({
  selector: 'rt-requisitions-location-form',
  templateUrl: './requisitions-location-form.component.html',
  imports: [LocationsSectionComponent],
  providers: [
    { provide: LocationSectionTranslationsToken, useValue: translations },
    { provide: AssignLocationsFacade, useClass: AssignLocationsRequisitionFacade },
    { provide: UnassignLocationFacade, useClass: UnassignLocationRequisitionFacade },
    { provide: ReorderLocationsFacade, useClass: ReorderLocationsRequisitionFacade },
    LocationsAnalytics,
  ],
})
export class RequisitionsLocationFormComponent {
  @Input() public form: FormGroup<RequisitionForm>;
  @Input() public isFormEditable: boolean;

  public LocationsSectionViewContext = LocationsSectionViewContext;

  public get locationsControl() {
    return this.form.controls.locationIds!;
  }
}
